
import CommondNoData from "@/components/NoData.vue";
import {
  onBeforeMount,
  onUnmounted,
  onMounted,
  ref,
  reactive,
  computed,
  inject,
  watch,
} from "vue";
export default {
  name: 'CommentsRes',
  props: {
    commentInfo: {
      type: Object,
      default: () => ({
        status: true,
        commentDesc: ''
      })
    },
    progress:{
      type:Number,
      default:1
    }
  },
  setup(props, { emit }) {
    const $xesLog = inject("$xesLog") as any; // 埋点
    const commentInfo = computed(() => props.commentInfo)
    const defaultText = {
      pass: '非常认真的笔记，继续保持哦～',
      unpass: '有点失误了，再来一次让老师看看你的真实水平～',
    }
    return {
      defaultText,
      commentInfo
    };
  },
};
